// removed by extract-text-webpack-plugin
module.exports = {"AttendanceTable":"AttendanceTable","StudentTable":"StudentTable","FinanceTable":"FinanceTable","download-btn":"download-btn","download-success-text":"download-success-text","redownload-btn":"redownload-btn"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/Export/Modal.scss
// module id = 70Bv
// module chunks = 0